import React from "react";
import { ICluster } from "@river/interfaces";

export interface IClusterContext {
  cluster: ICluster | null;
  setCluster: (cluster: ICluster) => void;
}

export const ClusterContext = React.createContext<IClusterContext | null>(null);
